var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.750058 7.66667C0.750058 10.4051 2.96999 12.625 5.70839 12.625C8.44679 12.625 10.6667 10.4051 10.6667 7.66667C10.6667 6.49481 10.2579 5.41972 9.57817 4.57109C9.63107 4.54403 9.68392 4.51573 9.7282 4.47146L11.0791 3.12081C11.307 2.89296 11.307 2.52383 11.0791 2.29592C10.8513 2.06801 10.4822 2.06807 10.2542 2.29592L8.90331 3.64657C8.85897 3.6909 8.83068 3.74375 8.80362 3.79666C7.95504 3.11707 6.88007 2.70833 5.70833 2.70833C2.96993 2.70833 0.750058 4.92821 0.750058 7.66667ZM3.95839 7.08333H5.12506V5.91667C5.12506 5.59426 5.38627 5.33333 5.70839 5.33333C6.03051 5.33333 6.29172 5.59426 6.29172 5.91667V7.08333H7.45839C7.78051 7.08333 8.04172 7.34426 8.04172 7.66667C8.04172 7.98907 7.78051 8.25 7.45839 8.25H6.29172L6.29172 9.41667C6.29172 9.73907 6.03051 10 5.70839 10C5.38627 10 5.12506 9.73907 5.12506 9.41667L5.12506 8.25H3.95839C3.63627 8.25 3.37506 7.98907 3.37506 7.66667C3.37506 7.34426 3.63627 7.08333 3.95839 7.08333ZM3.95839 1.54167C3.63627 1.54167 3.37506 1.28074 3.37506 0.958333C3.37506 0.635925 3.63627 0.375 3.95839 0.375L7.45839 0.375C7.78051 0.375 8.04172 0.635925 8.04172 0.958333C8.04172 1.28074 7.78051 1.54167 7.45839 1.54167L3.95839 1.54167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock-icon.960d33dad47f6050b8e9004ccb5deef3.svg";
export { ForwardRef as ReactComponent };